import { ResourceLanguage } from 'i18next'
import { Translation } from '../translation'

export const french: Translation & ResourceLanguage = {
    pageTitles: {
        coacheeLogin: 'Connectez-vous à votre compte',
    },
    titles: {
        logIn: 'connecter à Sama',
    },
    subTitles: {
        welcome: 'Pour débuter suivre le lien.',
        appDownload: "OU TÉLÉCHARGER L'APPLICATION",
    },
    buttons: {
        continue: 'Continuer',
    },
}
